/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonHomeActiveDelegationAmountInfo = {
    STKTP: BabylonHomeActiveDelegationAmountInfo.STKTP;
    ACTDLGAMT: string;
    ACTDLGVAL: string;
    AMT24: string;
};

export namespace BabylonHomeActiveDelegationAmountInfo {

    export enum STKTP {
        BTC_STAKING = 'BTC_STAKING',
    }


}

